/*
 * Reviewtje: productpagina.
 *
 * Drie dingen, allemaal rond hetzelfde <form action="/cart/add">:
 *
 *  1. Staffelkiezer. Onze varianten zijn staffels ("10–24 stuks") met een prijs
 *     PER STUK. Variant en aantal moeten dus bij elkaar passen, anders rekent
 *     Shopify de verkeerde stukprijs af. Deze code houdt ze gesynchroniseerd:
 *     klik je een staffel, dan springt het aantal naar het minimum; type je een
 *     aantal, dan springt de staffel mee.
 *  2. Gegevensuitvraag. Bedrijfsnaam + plaats gaan als line item properties mee.
 *     Leeg laten mag alleen als de klant aanvinkt dat hij zelf instelt.
 *  3. Meelopende koopbalk zodra de echte knop uit beeld is.
 *
 * De velden staan buiten het <form> en horen erbij via het form-attribuut;
 * FormData() pakt die gewoon mee (net als de standaard-aantalkiezer van Refresh).
 */
(function () {
  'use strict';

  function euro(cents, currency) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: currency || 'EUR',
    }).format(cents / 100);
  }

  function initBuyBlock(root) {
    if (root.dataset.rvReady === 'true') return;
    root.dataset.rvReady = 'true';

    var formId = root.dataset.rvForm;
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    var currency = root.dataset.rvCurrency || 'EUR';
    var variantInput = form.querySelector('input[name="id"]');
    var qtyInput = root.querySelector('[data-rv-qty]');
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-rv-tier]'));
    var totalEl = root.querySelector('[data-rv-total]');
    var totalNoteEl = root.querySelector('[data-rv-total-note]');
    var maxNote = root.querySelector('[data-rv-max-note]');
    var minus = root.querySelector('[data-rv-minus]');
    var plus = root.querySelector('[data-rv-plus]');

    if (!tiers.length || !qtyInput || !variantInput) return;

    var data = tiers.map(function (el) {
      return {
        el: el,
        id: el.dataset.variantId,
        min: parseInt(el.dataset.min, 10) || 1,
        max: parseInt(el.dataset.max, 10) || 0, // 0 = geen bovengrens
        price: parseInt(el.dataset.price, 10) || 0,
      };
    });

    var lowestMin = data.reduce(function (acc, t) {
      return Math.min(acc, t.min);
    }, data[0].min);

    // Boven de hoogste koopbare trap gaat het via een offerte (250+ / 500+),
    // dus daar knippen we af in plaats van stilzwijgend de vorige prijs te rekenen.
    var highestMax = data[data.length - 1].max;

    /** Welke staffel hoort bij dit aantal? Valt terug op de hoogste staffel. */
    function tierForQty(qty) {
      var match = data[0];
      for (var i = 0; i < data.length; i++) {
        if (qty >= data[i].min && (data[i].max === 0 || qty <= data[i].max)) return data[i];
        if (qty >= data[i].min) match = data[i];
      }
      return match;
    }

    var current = data[0];

    function render() {
      var qty = parseInt(qtyInput.value, 10) || current.min;

      tiers.forEach(function (el, i) {
        var active = data[i] === current;
        el.setAttribute('aria-checked', active ? 'true' : 'false');
        el.tabIndex = active ? 0 : -1;
      });

      variantInput.value = current.id;
      variantInput.disabled = false;

      var total = current.price * qty;
      if (totalEl) totalEl.textContent = euro(total, currency);
      if (totalNoteEl) {
        totalNoteEl.textContent =
          qty + ' × ' + euro(current.price, currency) + ' ' + (root.dataset.rvTaxNote || '');
      }

      if (minus) minus.disabled = qty <= lowestMin;
      if (plus) plus.disabled = highestMax > 0 && qty >= highestMax;

      // De koopbalk toont hetzelfde bedrag als de knop eronder.
      var sticky = document.querySelector('[data-rv-sticky]');
      if (sticky) {
        var stickyPrice = sticky.querySelector('[data-rv-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = qty + ' stuks · ' + euro(total, currency);
      }

      root.dispatchEvent(
        new CustomEvent('reviewtje:change', {
          bubbles: true,
          detail: { variantId: current.id, quantity: qty, total: total },
        })
      );
    }

    function selectTier(tier, moveQty) {
      current = tier;
      var qty = parseInt(qtyInput.value, 10) || 0;
      if (moveQty && (qty < tier.min || (tier.max && qty > tier.max))) {
        qtyInput.value = tier.min;
      }
      qtyInput.min = tier.min;
      render();
    }

    tiers.forEach(function (el, i) {
      el.addEventListener('click', function () {
        selectTier(data[i], true);
      });
      el.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        var next = event.key === 'ArrowDown' ? i + 1 : i - 1;
        if (next < 0) next = data.length - 1;
        if (next >= data.length) next = 0;
        tiers[next].focus();
        selectTier(data[next], true);
      });
    });

    function applyQty(value) {
      var qty = parseInt(value, 10);
      if (isNaN(qty) || qty < lowestMin) qty = lowestMin;

      var capped = highestMax > 0 && qty > highestMax;
      if (capped) qty = highestMax;

      qtyInput.value = qty;
      if (maxNote) maxNote.hidden = !capped;
      selectTier(tierForQty(qty), false);
    }

    qtyInput.addEventListener('change', function () {
      applyQty(qtyInput.value);
    });
    qtyInput.addEventListener('blur', function () {
      applyQty(qtyInput.value);
    });
    if (minus) {
      minus.addEventListener('click', function () {
        applyQty((parseInt(qtyInput.value, 10) || lowestMin) - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        applyQty((parseInt(qtyInput.value, 10) || lowestMin) + 1);
      });
    }

    // Beginstand: de staffel die bij het ingevulde aantal hoort.
    selectTier(tierForQty(parseInt(qtyInput.value, 10) || lowestMin), false);
  }

  function initSetup(block) {
    if (block.dataset.rvReady === 'true') return;
    block.dataset.rvReady = 'true';

    var formId = block.dataset.rvForm;
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    var fields = block.querySelector('[data-rv-setup-fields]');
    var inputs = Array.prototype.slice.call(block.querySelectorAll('[data-rv-required]'));
    var self = block.querySelector('[data-rv-self]');
    var selfProperty = block.querySelector('[data-rv-self-property]');
    var error = block.querySelector('[data-rv-setup-error]');

    function clearError() {
      if (error) error.hidden = true;
      inputs.forEach(function (input) {
        input.classList.remove('is-error');
      });
    }

    function syncSelf() {
      var on = !!(self && self.checked);
      if (fields) fields.hidden = on;
      // Uitgeschakelde velden gaan niet mee in FormData, precies wat we willen.
      inputs.forEach(function (input) {
        input.disabled = on;
      });
      if (selfProperty) selfProperty.disabled = !on;
      if (on) clearError();
    }

    if (self) self.addEventListener('change', syncSelf);
    inputs.forEach(function (input) {
      input.addEventListener('input', clearError);
    });
    syncSelf();

    // Capture-fase: draait vóór de submit-handler van <product-form>, zodat we
    // die met stopImmediatePropagation kunnen tegenhouden.
    form.addEventListener(
      'submit',
      function (event) {
        if (self && self.checked) return;
        var missing = inputs.filter(function (input) {
          return input.value.trim() === '';
        });
        if (!missing.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        missing.forEach(function (input) {
          input.classList.add('is-error');
        });
        if (error) error.hidden = false;
        missing[0].focus();
        block.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      true
    );
  }

  function initSticky(bar) {
    if (bar.dataset.rvReady === 'true') return;
    bar.dataset.rvReady = 'true';

    var formId = bar.dataset.rvForm;
    var form = formId ? document.getElementById(formId) : null;
    var anchor = document.getElementById(bar.dataset.rvAnchor || '');
    var button = bar.querySelector('[data-rv-sticky-submit]');

    if (!form || !anchor) return;

    if (button) {
      button.addEventListener('click', function () {
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.click();
      });
    }

    // Zichtbaar zodra de echte koopknop voorbij de bovenkant van het scherm is.
    // Bewust met een scroll-listener en niet met IntersectionObserver: die geeft
    // alleen iets door bij het kruisen van een drempel, wat in sommige
    // omgevingen (en in de theme-editor-preview) niet betrouwbaar aankomt.
    var ticking = false;

    function update() {
      ticking = false;
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    document.querySelectorAll('[data-rv-buy]').forEach(initBuyBlock);
    document.querySelectorAll('[data-rv-setup]').forEach(initSetup);
    document.querySelectorAll('[data-rv-sticky]').forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // De theme-editor hertekent secties; dan opnieuw initialiseren.
  document.addEventListener('shopify:section:load', init);
})();
